module.exports = __webpack_public_path__ + "static/media/no-fabric-found.3fbf6a17.svg";